module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAAAXNSR0IArs4c6QAAAT1JREFUOBFjZCADuC5+5Mfwn3EhAwPjDka3hY89/zMyzAWaI4nNLMb/DI274mUbYHIO8+9zsDKzHATyzYD4DRM+zTBNMNpt0VNfNmaWK/+ZGPOBYsf+MTLEsgAZYJt3x8kywhRio90WPvH5z/BvDVCOjfEfw3IBjk/qq8O0fzFhU4wuBtbM+H8tSDMQ/2T8/z8LpBmkjqABmJoZAoFhsh2kGQTwGoCm+RcwQFE04zUAi+YAmM3AmGsAYZABoEDEAC6Ln3j//w/3M8hmuGaQYmDM1UM1NWB4wXnhE0tgIK0DKgAFGIZmqEY4hWEAMzBuidUMMgXDAAaGf6pAR84AJhZ7mJ/h1mFhYITBrjg5VyzqcAphcQFOtVglQC54DsSSrose/8eqAocgMN2/AEmBXJAC4+BQi034KdC2ZJAEAGzydbnazNgRAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/containers/product/list/Item/ic_edit_.png
// module id = 997
// module chunks = 0